import $ from 'jquery';
import wretch from 'wretch';

/**
 * @desc Renders click-through widget
 */
export default class ClickthroughWidget {
  /**
   * @param {string} widgetSelector
   */
  constructor(widgetSelector) {
    this.$widgetContainer = $(widgetSelector);

    this.init();
  }

  async init() {
    this.initialized = true;

    if (!this.$widgetContainer.length) {
      this.initialized = false;
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const widgetId = params.get('widgetid');
    const widgetType = params.get('widgetType');

    if (!widgetId || !widgetType) {
      return;
    }

    const result = await ClickthroughWidget.fetchClickThroughWidget(widgetId, widgetType);
    this.$widgetContainer.append(`<script type="text/javascript" src="${result.scriptLink}"></script>`);
    this.$widgetContainer.append(result.iframe);
  }

  static async fetchClickThroughWidget(widgetId, widgetType, baseUrl = window.location.origin) {
    try {
      return await wretch(`${baseUrl}/web3/api/cityzens/widgets/${widgetType}/${widgetId}/clickthrough`)
        .get()
        .json();
    } catch (e) {
      console.error(`An error occurred while fetching clickthrough widget: ${e}`);
      return null;
    }
  }
}
